import React from "react"
import { ExclusiveChoiceDropdown } from "dash-styled"

/**
 * Configuration for switching views
 */
export interface TableViewChooserProps<V extends string> {
    /**
     * The option which is currently applied (corresponds to `options[].id` )
     */
    applied: V
    /**
     * Configurations for all possible view options
     */
    options: {
        /**
         * Identifier for a view option
         */
        id: V
        /**
         * Text to be shown in the dropdown to choose view option.
         */
        label: string
    }[]
    /**
     * Callback function to handle changing view option
     */
    onChange: (id: V) => void
}

export function TableViewChooser<V extends string>({
    applied,
    options,
    onChange
}: TableViewChooserProps<V>) {
    const handleChange = (index: number) => onChange(options[index].id)

    return (
        <ExclusiveChoiceDropdown
            choices={options.map(v => v.label)}
            selectedIndex={options.findIndex(o => o.id === applied)}
            className="w-auto mr-2 text-gray-600"
            size="sm"
            onClick={handleChange}
        />
    )
}
